import React from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';
import { MEASURE_SCORE_BY_SKILL_NAME } from '../../constants/assessments';

const textForOneMeasure = `is not required for a composite score in Grade 2. It is available to support your district's dyslexia screening policy. Refer to your district's guidance on additional Grade 2 testing.`;

const textForMoreThanOneMeasure = `are not required for a composite score in Grade 2. They are available to support your district's dyslexia screening policy. Refer to your district's guidance on additional Grade 2 testing.`;

const BMLNFPSFBanner = ({ studentUid }) => {
    const bannerContext = useBannerContext();
    const { classId } = useAppContext();
    const {
        actions: { hideBMLNFPSFBanner },
        isBannerVisible,
        getBannerProperty,
    } = bannerContext;

    const dismissHandler = () =>
        hideBMLNFPSFBanner({
            classId,
            studentUid,
        });

    const isBMLNFPSFBannerVisible = isBannerVisible(classId, studentUid, 'isBMLNFPSFBannerVisible');
    const skillNames = getBannerProperty(classId, studentUid, 'skillNames');

    const bunnerTitle = skillNames
        .map(skillName => MEASURE_SCORE_BY_SKILL_NAME[skillName])
        .join(' and ');

    const bunnerText = skillNames.length === 1 ? textForOneMeasure : textForMoreThanOneMeasure;

    const text = `${bunnerTitle} ${bunnerText}`;

    return isBMLNFPSFBannerVisible ? (
        <Banner
            isInformation
            isDismissible
            dismissHandler={dismissHandler}
            className='dashboard-section dashboard-bm-section'
        >
            <div>
                <div className='dashboard-title'>{bunnerTitle}</div>
                <div className='dashboard-text'>{text}</div>
            </div>
        </Banner>
    ) : null;
};

BMLNFPSFBanner.propTypes = {
    studentUid: PropTypes.string.isRequired,
};

export default BMLNFPSFBanner;
